var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 279,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-254 -279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.2 308.2C294 307.4 294.5 306.3 294.5 305.1 294.5 303.9 294 302.8 293.2 302L279.4 288.3C278.6 287.5 277.5 287 276.4 287 275.3 287 274.1 287.5 273.3 288.3L271.8 289.8 291.7 309.7 293.2 308.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3 343.5C312.9 343.9 312.3 344.1 311.8 344.1 311.3 344.1 310.7 343.9 310.3 343.5L285.5 318.8C285.1 318.4 284.9 317.8 284.9 317.3 284.9 316.8 285.1 316.2 285.5 315.8L288.6 312.8 268.7 292.9C267.4 294.2 266.2 295.4 265.4 296.2 263.4 298.1 262.2 300.6 262.1 303.3 261.8 307.8 262.9 312.1 264.4 316.3 266 320 268.1 323.5 270.4 326.8 278.6 339.1 288.9 349.8 300.9 358.3 302.9 359.8 305 361.1 307.2 362.3 312.2 364.8 317.5 366.6 323.2 367 327 367.3 330.8 365.8 333.4 363L336.1 360.3 316.3 340.4 313.3 343.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.7 349.6 326.9 335.8C326.1 335 325 334.5 323.8 334.5 322.6 334.5 321.5 335 320.7 335.8L319.2 337.4 339.1 357.3 340.6 355.8C341.4 355 341.9 353.9 341.9 352.7 341.9 351.5 341.5 350.4 340.7 349.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e6eb2f29c3cbe0eecc23191d0e4801db.svg";
export { ForwardRef as ReactComponent };